import deTrans from "./de.json";

let de = {
  translations: deTrans,
};

export default de;
